import type { HistoryItem } from "../stores/historyStore";
import { timeAgo } from "../utils/format";
import { getScoreColorClass } from "../utils/score";

interface Props {
  history: HistoryItem[];
  onAnalyze: (name: string, years: number) => void;
  onRemove: (code: string) => void;
}

export default function AnalysisHistory({ history, onAnalyze, onRemove }: Props) {
  if (history.length === 0) return null;

  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-3">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" />
        </svg>
        <span className="text-zinc-600 dark:text-zinc-500 text-xs font-medium">최근 분석</span>
      </div>
      <div className="flex gap-2 flex-wrap">
        {history.map((h) => (
          <div key={h.code} className="group relative">
            <button
              onClick={() => onAnalyze(h.name, h.years)}
              className="flex items-center gap-2.5 px-4 py-2.5 bg-white dark:bg-zinc-900/80 border border-zinc-200 dark:border-zinc-800 rounded-xl text-left cursor-pointer font-[inherit] transition-all hover:border-indigo-500 hover:shadow-md dark:hover:bg-zinc-800 shadow-sm"
            >
              <div>
                <div className="text-sm font-semibold text-zinc-950 dark:text-white">{h.name}</div>
                <div className="text-[11px] text-zinc-400 dark:text-zinc-500">{h.code} / {h.market}</div>
              </div>
              <div className="text-right">
                <div className={`text-sm font-bold ${getScoreColorClass(h.totalScore)}`}>{h.totalScore}점</div>
                <div className="text-[11px] text-zinc-400 dark:text-zinc-500">{timeAgo(h.analyzedAt)}</div>
              </div>
            </button>
            <button
              onClick={(e) => { e.stopPropagation(); onRemove(h.code); }}
              className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-zinc-200 dark:bg-zinc-700 text-zinc-500 dark:text-zinc-400 text-xs flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-500 hover:text-white cursor-pointer"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
